import React from 'react';
import { useTranslation } from 'react-i18next';

const ReportFilters = ({ filters, onFilterChange }) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);
  const monthNames = t("admin.reports.filters.months", { returnObjects: true });
const months = [
  { value: null, label: t("admin.reports.filters.all_months") },
  ...monthNames.map((month, index) => ({
    value: index + 1,
    label: month
  }))
];

  const handleYearChange = (e) => {
    onFilterChange({
      ...filters,
      year: parseInt(e.target.value)
    });
  };

  const handleMonthChange = (e) => {
    const value = e.target.value === '' ? null : parseInt(e.target.value);
    onFilterChange({
      ...filters,
      month: value
    });
  };

  return (
    <div className="report-filters">
      <div className="filter-group">
        <label htmlFor="year-select" className="filter-label">
          {t('admin.reports.filters.year')}
        </label>
        <select
          id="year-select"
          className="filter-select"
          value={filters.year}
          onChange={handleYearChange}
        >
          {years.map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="month-select" className="filter-label">
          {t('admin.reports.filters.month')}
        </label>
        <select
          id="month-select"
          className="filter-select"
          value={filters.month || ''}
          onChange={handleMonthChange}
        >
          {months.map(month => (
            <option key={month.value || 'all'} value={month.value || ''}>
              {month.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ReportFilters;